function lpSelect (element) {

	if (!element) {

		return;

	}

	// Variables and Functions
	const wrapperSelector = '.lpSelectWrapper';
	const wrapper = document.querySelector(wrapperSelector);
	const isSelectHidden = () => wrapper.classList.contains('closed');
	const isInFocus = () => document.activeElement.closest(wrapperSelector);
	const hideSelect = () => {

		const activeItem = wrapper.querySelector('li.active');
		if (!wrapper.classList.contains('closed')) {

			const mainSelector = wrapper.querySelector('.mainSelector');
			mainSelector.setAttribute('aria-expanded', 'false');
			mainSelector.focus();

		}

		wrapper.classList.add('closed');

		if (activeItem) {

			activeItem.classList.remove('active');

		}

	};

	const movePointer = (direction) => {

		if (wrapper.classList.contains('closed')) {

			return;

		}
		const selectItems = element.querySelectorAll('li');
		const currentActive = element.querySelector('li.selected');

		// no elements currently being highlighted
		if (!currentActive) {

			selectItems[0].classList.add('active');

		} else {

			let pointerPosition = 0;

			selectItems.forEach((item, index) => {

				if (item.classList.contains('active')) {

					item.classList.remove('active');

					if (direction === 'up') {

						pointerPosition = index <= 0 ? selectItems.length - 1 : index - 1;

					}

					if (direction === 'down') {

						pointerPosition = index >= selectItems.length - 1 ? 0 : index + 1;

					}

				}

			});

			selectItems[pointerPosition].classList.add('active');

		}

	};

	const clickHandler = (e, forceHide) => {

		let el = e.target;

		// if clicking inside the lpSelectWrapper, otherwise hide lpSelect
		if (!el.closest('.mainSelector') && (el.closest(wrapperSelector) || forceHide)) {

			if (forceHide) {

				el = wrapper.querySelector('li.active');

			}

			// set el as closest li tag
			if (el && el.nodeName.toLowerCase() !== 'li') {

				el = el.closest('li');

			}

			// if el exists
			if (el) {

				// if clicking on input tag, ignore. Otherwise triggers a 2nd click event
				if (e.target.nodeName.toLowerCase() !== 'input' || forceHide) {

					const mainSelector = wrapper.querySelector('.mainSelector');

					wrapper.classList.toggle('closed');
					element.querySelectorAll('li').forEach((item) => {

						if (!item.classList.contains('main')) {

							item.classList.remove('selected');

						}

					});
					mainSelector.focus();
					mainSelector.setAttribute('aria-expanded', 'false');

					el.classList.add('selected', 'active');

					if (el.querySelector('.listHeader')) {

						mainSelector.innerHTML = el.querySelector('.listHeader').innerHTML;

					} else {

						mainSelector.innerHTML = el.querySelector('.listName').innerHTML;

					}

				}

			}

		} else if (el.closest('.mainSelector') && wrapper.classList.contains('closed')) {

			const mainSelector = wrapper.querySelector('.mainSelector');
			mainSelector.setAttribute('aria-expanded', 'true');
			element.querySelectorAll('li').forEach((item) => {

				if (item.classList.contains('selected')) {

					item.classList.add('active');

				}

			});

			wrapper.classList.toggle('closed');
			element.focus();

		} else {

			hideSelect();

		}

	};
	const enterPressHandler = (e) => {

		const activeListEl = wrapper.querySelector('li.active input');

		if (activeListEl) {

			activeListEl.click();
			clickHandler(e, true);

		}

	};

	// Events
	document.addEventListener('click', (e) => {

		clickHandler(e);

	});

	document.addEventListener('focusin', (e) => {

		// tabbing outside the dropdown, if it is open we need to shut it.
		if (!isInFocus() && !isSelectHidden()) {

			hideSelect();

		}

	});

	element.addEventListener('keydown', (e) => {

		switch (e.which) {

			/* SPACE */
			case 32:
				// if dropdown is focused, open it
				if (wrapper.querySelector('.lpSelect') === document.activeElement) {

					e.preventDefault();
					const elem = wrapper.querySelector('li.multiProdSizeOptions__option.selected');
					elem.click();

				}
				break;
			/* ESC */
			case 27:
				e.preventDefault();
				hideSelect();
				break;
			/* ENTER */
			case 13:
				e.preventDefault();
				enterPressHandler(e);
				break;
			/* UP */
			case 38:
				e.preventDefault();
				movePointer('up');
				break;
			/* DOWN */
			case 40:
				e.preventDefault();
				movePointer('down');
				break;
			default:
				break;

		}

	});
	element.addEventListener('mouseover', (e) => {

		let el = e.target;

		if (wrapper.classList.contains('closed')) {

			return;

		}

		if (el && el.nodeName.toLowerCase() !== 'li') {

			el = el.closest('li');

		}

		if (el) {

			const currentActive = element.querySelector('li.active');

			if (currentActive) {

				currentActive.classList.remove('active');

			}

			el.classList.add('active');

		}

	});

	// Initialize
	const li = element.querySelector('li.selected');
	const el = document.createElement('button');
	const name = li ? li.querySelector('.listName').innerText : '';

	el.classList.add('mainSelector');
	el.setAttribute('aria-expanded', 'false');
	el.setAttribute('aria-haspopup', 'true');
	el.innerHTML = `${name}`;
	wrapper.insertBefore(el, element);

}

export default lpSelect;
